// Vite entrypoint for main application

// Bootstrap is self-hosted in public/vendor and loaded as a classic
// <script> tag in the layout, BEFORE this bundle — it exists here only as
// a global (window.bootstrap). Charts are Chart.js via lib/appcharts.js.

// Theme controller — first, so the effective theme classes are in place
// before any page entrypoint draws a chart.
import '../custom/theme'
// Interface language switcher (account menu)
import '../custom/locale'

// Hotwire: Turbo Drive (navigation + form submissions without full reloads;
// replaces Turbolinks and rails-ujs) and Stimulus (element-bound behaviour,
// see controllers/). Importing Turbo starts Drive.
import * as Turbo from '@hotwired/turbo'
import * as ActiveStorage from '@rails/activestorage'
import '../controllers'

window.Turbo = Turbo

// Calendar
import Calendar from 'js-year-calendar'
import 'js-year-calendar/dist/js-year-calendar.css'
// Dutch month/day names for the year calendar; without this the grid stays
// English even when the app runs in Dutch (calendars.js passes `language`).
import 'js-year-calendar/locales/js-year-calendar.nl'
window.Calendar = Calendar

// Icons — Lucide rendered through the <i class="fas fa-…"> hook (lib/icons.js)
import '../lib/icons'

// Service-worker registration (PWA offline fallback)
import '../lib/pwa'

// Topbar-notificatiebel (in-app inbox + push-opt-in voor o.a. planners)
import '../custom/notif_bell'

// Custom javascript
import '../custom/custom'
// Styled confirm/alert modals (window.appConfirm / window.appAlert)
import '../custom/confirm_modal'
// Global flash toast popups (shared/_flash_toasts in the layouts)
import '../custom/flash_toasts'

// Channels
import '../channels'

// data-turbo-confirm → the app's own styled dialog (returns a Promise<boolean>)
const confirmWithModal = (message, element) => window.appConfirm(message, {
  danger: !!(element && element.classList && (element.classList.contains('btn-alert') || element.classList.contains('btn-icon--danger') || element.classList.contains('text-danger')))
})
if (Turbo.config && Turbo.config.forms) Turbo.config.forms.confirm = confirmWithModal
else if (Turbo.setConfirmMethod) Turbo.setConfirmMethod(confirmWithModal)

// Turbo hygiene: an open modal/drawer/dropdown must not survive a visit —
// their backdrops live on <body>, which Turbo replaces, but the classes it
// set on <body>/<html> would linger.
document.addEventListener('turbo:before-render', () => {
  document.querySelectorAll('.modal-backdrop, .offcanvas-backdrop').forEach((el) => el.remove())
  document.body.classList.remove('modal-open')
  document.body.style.removeProperty('overflow')
  document.body.style.removeProperty('padding-right')
  document.documentElement.classList.remove('sidebar-open', 'palette-open')
})
// Reset the window scroll on a new visit (Turbo restores it on back/forward).
document.addEventListener('turbo:visit', (e) => {
  if (e.detail && e.detail.action === 'advance') window.scrollTo(0, 0)
})

ActiveStorage.start()
